export interface Offer{
    Id?: number;
    Title: string;
    SubTitle: string;
    TypeOfferImages: number;
    Images: [];
    Rows: {}
    ProductIds: []
}

export interface OfferUpdateImageAndTiner{
    Id?: number;
    Title: string;
    SubTitle: string;
    TypeOfferImages: number;
    status?: number;
    rows:  OfferRows[];
    // OfferItems:  Array<OfferItemsImage | OfferItemsSlider>;
}
export interface OfferUpdateSlider{
    Id?: number;
    Title: string;
    SubTitle: string;
    TypeOfferImages: number;
    status?: number;
    OfferItems:  OfferItemsSlider[];
}

export interface OfferRows{
    imageOfferRowId: string;
    offerItems:  OfferItemsImageAndTimer[];
}

export interface OfferItemsImageAndTimer {
    id?: number,
    imageId: string,
    urlSingle?: string,
    imageUrl?: string,
    order?: number,
    colSize: string,
    imageSizeType?: number,
    typeOffer: number,
    startDate?: string,
    endDate?: string,
    darkMode?: boolean
    customImage?: File | null;
    isMobileVersion: boolean;
    parentImageId: string;
    imageOfferRowId?: string;
}
export interface OfferItemsSlider{
    productId: number,
    detailListId: number,
    productName: string,
    mainImage:string,
    salePrice: number,
    discountPrice: number,
    categoryName: string
}

export interface UpdateOffer{
    Title: string;
    SubTitle: string;
    TypeOfferImages: number;
    Images: [];
    LayoutChanges: {}
}

export enum ImageSizeType {
  EC44 = 1,
  EC66 = 2,
  ER84 = 3,
  ER14 = 4,
}